import { Box, Typography } from '@mui/material'
import { ReactNode } from 'react'

interface StepProps {
  stepNum: number
  left: ReactNode
  right: ReactNode
  fullHeight?: boolean
  backgroundImage?: { src: string }
}

const Step = ({
  stepNum,
  left,
  right,
  fullHeight,
  backgroundImage,
}: StepProps) => {
  return (
    <Box
      sx={{
        height: fullHeight ? '100vh' : 'fit-content',
        display: 'flex',
        background: backgroundImage && `url(${backgroundImage.src})  `,
        backgroundSize: 'cover',
      }}
    >
      <Box
        sx={{
          width: '40%',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          marginTop: stepNum === 2 ? '30vh' : '',
        }}
      >
        {left}
      </Box>
      <Box
        sx={{
          width: '20%',
          height:
            stepNum === 3
              ? '18vh'
              : stepNum === 1
              ? 'calc(30vh + 3.75rem)'
              : 'calc(30vh + 3.75rem)',
          display: 'flex',
          alignItems: stepNum === 3 || stepNum === 2 ? 'flex-end' : 'center',
        }}
      >
        <Box
          sx={{
            border: '2px solid',
            borderColor: stepNum === 3 ? '#2E004D' : ' white',
            minWidth: '3.75rem',
            maxWidth: '3.75rem',
            height: '3.75rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '10vh 0 0 4rem',
            '&::before': {
              content: "''",
              height: stepNum === 2 ? '26vh' : stepNum === 3 ? '6vh' : 0,
              width: '2px',
              backgroundColor: stepNum === 3 ? '#2E004D' : ' white',
              position: 'absolute',
              top: '0',
            },
            '&::after': {
              content: "''",
              height: stepNum !== 3 ? '70vh' : 0,
              width: '2px',
              backgroundColor: ' white',
              position: 'absolute',
              top: stepNum === 1 ? '52vh' : '42vh',
            },
          }}
        >
          <Typography
            variant="bodyLato1"
            sx={{
              color: stepNum === 3 ? '#2E004D' : ' white',
              fontWeight: 800,
              fontSize: '1.25rem',
            }}
          >
            {stepNum}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          width: '40%',
          marginTop: stepNum === 1 ? '20vh' : '',
        }}
      >
        {right}
      </Box>
    </Box>
  )
}

export default Step
